module.exports = __webpack_public_path__ + "static/tutors-f546c767c13a2fa831f802bba3c654b1.jpg";